// extracted by mini-css-extract-plugin
module.exports = {"container":"EntityTable_container__Z36QO","controls":"EntityTable_controls__3kNlb","body":"EntityTable_body__35SWf","entityTableHead":"EntityTable_entityTableHead__2niAc"};